'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.success = exports.message = exports.info = exports.warning = exports.error = exports.update = exports.dismiss = exports.toastActionCreator = undefined;

var _types = require('./types');

var types = _interopRequireWildcard(_types);

var _reactToastify = require('react-toastify');

var _uniqueId = require('./utils/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var toastActionCreator = exports.toastActionCreator = function toastActionCreator(type) {
    return function (message) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return {
            type: types.TOAST_MESSAGE,
            payload: Object.assign({ id: options.id || (0, _uniqueId2.default)('toast') }, options, { message: message,
                type: type })
        };
    };
};
var dismiss = exports.dismiss = function dismiss(id) {
    return {
        type: types.TOAST_DISMISS,
        payload: { id: id }
    };
};
var update = exports.update = function update(id, options) {
    return {
        type: types.TOAST_UPDATE,
        payload: { id: id, options: options }
    };
};
var error = exports.error = toastActionCreator(_reactToastify.toast.TYPE.ERROR);
var warning = exports.warning = toastActionCreator(_reactToastify.toast.TYPE.WARNING);
var info = exports.info = toastActionCreator(_reactToastify.toast.TYPE.INFO);
var message = exports.message = toastActionCreator(_reactToastify.toast.TYPE.DEFAULT);
var success = exports.success = toastActionCreator(_reactToastify.toast.TYPE.SUCCESS);